<template>
  <div class="mapbox-container">
    <mapbox
      :access-token="accessToken"
      :map-options="{
        style: 'mapbox://styles/appswithlove/ck6qy292404qg1inv9ubxrl03',
        center: [7.593740260641175, 47.561587809616569],
        zoom: 14,
        minZoom: 13,
        maxZoom: maxZoom, // second zoom level
      }"
      :geolocate-control="{
        show: true,
        position: 'top-right',
        trackUserLocation: true,
      }"
      @map-load="loaded"
      @map-init="mapInitialized"
      @geolocate-geolocate="geolocate"
    />

    <teaser-preview
      v-if="preview"
      :offer="preview"
      :tops="tops"
      :maps="maps"
      :translate-detail="translateDetail"
    ></teaser-preview>

    <fairground-preview
      v-if="fairground"
      :fairground="fairground"
      :maps="maps"
      :translate-detail="translateDetail"
      :hide-offers="hideOffers"
    ></fairground-preview>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl-vue';
import TeaserPreview from '../components/TeaserPreview.vue';

const MAP_IMAGES = [
  {
    src: '/images/map/map-01.png',
    position: [7.588734812392602, 47.547711895704026],
    fairgroundId: '',
  },
  {
    src: '/images/map/map-31.png',
    position: [7.609240113743368, 47.557982430964614],
    fairgroundId: '',
    iconSize: 0.28,
  },
  {
    src: '/images/map/map-03.png',
    position: [7.607874734388361, 47.5673818773125],
    fairgroundId: '',
  },
  {
    src: '/images/map/map-04.png',
    position: [7.581658643539697, 47.55841527624793],
    fairgroundId: 'petersplatz-and-haeaefelimaeaert',
  },
  {
    src: '/images/map/map-05.png',
    position: [7.583591844556452, 47.55865541595227],
    fairgroundId: 'petersplatz-and-haeaefelimaeaert',
  },
  {
    src: '/images/map/map-08.png',
    position: [7.589956845658264, 47.55380487206949],
    fairgroundId: 'barfuesserplatz',
  },
  {
    src: '/images/map/map-16-1.png',
    position: [7.590782671700623, 47.56215146032855],
    fairgroundId: 'kasernenareal',
  },
  {
    src: '/images/map/map-09.png',
    position: [7.590321765848103, 47.55681922282457],
    fairgroundId: 'muensterplatz',
  },
  {
    src: '/images/map/map-06.png',
    position: [7.58717307643542, 47.557579614353244],
    fairgroundId: '',
  },
  {
    src: '/images/map/map-10.png',
    position: [7.591557617400285, 47.55664972891719],
    iconSize: 0.28,
    fairgroundId: 'muensterplatz',
  },
  {
    src: '/images/map/map-12.png',
    position: [7.595092093985045, 47.56170364612379],
    fairgroundId: '',
  },
  {
    src: '/images/map/map-13.png',
    position: [7.5914783205576555, 47.562895841606434],
    fairgroundId: 'kasernenareal',
  },
  {
    src: '/images/map/map-18.png',
    position: [7.6000163952354, 47.56337510923274],
    fairgroundId: 'messeplatz',
    iconSize: 0.2,
  },
  {
    src: '/images/map/map-20.png',
    position: [7.602577493406812, 47.56512866431598],
    fairgroundId: '',
  },
  {
    src: '/images/map/map-22.png',
    position: [7.603372079638376, 47.5609097248761],
    iconSize: 0.28,
    fairgroundId: 'rosentalanlage',
  },
  {
    src: '/images/map/map-23.png',
    position: [7.5805421065477105, 47.55810682671327],
    fairgroundId: 'petersplatz-and-haeaefelimaeaert',
  },
  {
    src: '/images/map/map-33.png',
    position: [7.599552809362137, 47.56530544682383],
    fairgroundId: 'hallenmesse',
    iconSize: 0.37,
  },
  {
    src: '/images/map/map-37.png',
    position: [7.58338448838154, 47.559156398249854],
    fairgroundId: 'petersplatz-and-haeaefelimaeaert',
    iconSize: 0.2,
  },
  {
    src: '/images/map/map-28-1.png',
    position: [7.589667379332383, 47.554862895352244],
    iconSize: 0.25,
    fairgroundId: 'barfuesserplatz',
  },
  {
    src: '/images/map/map-27.png',
    position: [7.601482694758602, 47.56492530712572],
    fairgroundId: 'messeplatz',
    iconSize: 0.13,
  },
  {
    src: '/images/map/map-14.png',
    position: [7.590517372641727, 47.56311415260407],
    fairgroundId: 'kasernenareal',
    iconSize: 0.35,
  },
  {
    src: '/images/map/map-38.png',
    position: [7.602942926196249, 47.56396486659759],
    fairgroundId: 'rosentalanlage',
    iconSize: 0.26,
  },
];

const MAP_ENTERS = [
  // Barfusserplatz
  [7.589853893407366, 47.554658855562735],
  [7.5893595509274405, 47.55465347451235],

  // Plan Halle + Sperrstrasse mit Ein- und Ausgang.pdf
  [7.598211695596859, 47.56632935858744],
  [7.598965564783981, 47.566517135660206],

  // kasernenareal
  [7.5905801805674855, 47.56283359188646],
  [7.59133412646878, 47.563431591019594],

  // muensterplatz
  [7.591773225866973, 47.556327345959374],
  [7.591243421832672, 47.556899023908386],

  // rosentalanlage
  [7.602687257968483, 47.564123411374396],
  [7.601999389656015, 47.563903768871626],
];

const MAP_ENTER_SOURCE = '/images/map/enter-icon.png';

export default {
  name: 'AppMap',
  components: { Mapbox, TeaserPreview },
  props: {
    selectedItem: {
      type: [Object, null],
      required: false,
      default: null,
    },
    fairgroundsGeoJson: {
      type: Array,
      required: true,
    },
    offersGeoJson: {
      type: Array,
      required: true,
    },
    offers: {
      type: Array,
      required: true,
    },
    allFairgrounds: {
      type: Object,
      required: true,
    },
    isMapOpen: {
      type: Boolean,
      default: false,
    },
    userPosition: {
      type: Array,
      default: () => [],
    },
    preview: {
      type: Object,
      default: null,
    },
    fairground: {
      type: Object,
      default: null,
    },
    maps: {
      type: String,
      default: 'Maps',
    },
    translateDetail: {
      type: String,
      required: true,
    },
    tops: {
      type: Object,
      required: true,
    },
    maxZoom: {
      type: Number,
      default: 19,
    },
    hideOffers: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      navigateToPosition: null,
      map: null,
      layersList: ['fairgrounds-data', 'offers-data'],
      accessToken: 'pk.eyJ1IjoiYXBwc3dpdGhsb3ZlIiwiYSI6ImNrYjZvbGczbDAwbngydG1wdDNpNWQ1d3oifQ.QZZde3PfKJv6k4YrXpjydw',
    };
  },
  computed: {
    offerIds() {
      return this.offers.map((offer) => offer.id);
    },
    selectedItemPosition() {
      if (!this.selectedItem) {
        return [];
      }

      if (this.selectedItem.type === 'offers') {
        return this.getFeaturePosition(this.offersGeoJson, this.selectedItem.id);
      }

      if (this.selectedItem.type === 'fairgrounds') {
        return this.getFeaturePosition(this.fairgroundsGeoJson, this.selectedItem.id);
      }

      return [];
    },
  },
  watch: {
    selectedItem(item) {
      this.selectItem(item);
    },
    isMapOpen() {
      this.map.resize();
    },
    offers() {
      if (!this.map || !this.map.isStyleLoaded()) {
        return;
      }
      const id = this.selectedItem && this.selectedItem.id;
      this.map.setPaintProperty('offers-data', 'fill-opacity', this.createFillOpacityOffersExpression(id));
    },
  },
  mounted() {
    try {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition((position) => {
            this.$emit('geolocate', [position.coords.longitude, position.coords.latitude]);
          });
        }
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.info(error.message);
    }
  },
  methods: {
    buildRouteMapboxUrl(center) {
      const coordinatesFrom = this.userPosition.join(',');
      const coordinatesTo = center.join(',');
      return `https://api.mapbox.com/optimized-trips/v1/mapbox/walking/${coordinatesFrom};${coordinatesTo}?overview=full&steps=true&geometries=geojson&source=first&access_token=${this.accessToken}`;
    },
    selectItem(item) {
      const id = item && item.id;
      this.map.setPaintProperty('fairgrounds-data', 'fill-opacity', null);
      this.map.setPaintProperty('offers-data', 'fill-opacity', this.createFillOpacityOffersExpression(null));

      if (!id) {
        return;
      }

      let position = null;
      let zoom = 18;

      if (item.type === 'offers') {
        this.map.setPaintProperty('offers-data', 'fill-opacity', this.createFillOpacityOffersExpression(id));
        position = this.getFeaturePosition(this.offersGeoJson, id);
        if (!position) {
          const offerData = this.offers.find((offer) => offer.id === id);

          if (!offerData) {
            return;
          }

          const offerFairground = this.allFairgrounds[offerData.fairgroundId];
          position = this.getFeaturePosition(this.fairgroundsGeoJson, offerFairground.slug);

          this.map.setPaintProperty(
            'fairgrounds-data',
            'fill-opacity',
            this.createFillOpacityExpression(offerFairground.slug),
          );
        }
      }

      if (item.type === 'fairgrounds') {
        this.map.setPaintProperty('fairgrounds-data', 'fill-opacity', this.createFillOpacityExpression(id));
        position = this.getFeaturePosition(this.fairgroundsGeoJson, id);
        zoom = 14;
      }

      this.map.flyTo({
        zoom: zoom,
        center: position,
      });
    },
    mapInitialized(map) {
      this.map = map;
    },
    geolocate(control, position) {
      this.$emit('geolocate', [position.coords.longitude, position.coords.latitude]);
    },
    loaded(map) {
      MAP_IMAGES.forEach((imageData, index) => setTimeout(this.loadImage(imageData), index * 10));

      map.addSource('fairgrounds', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          name: 'fairgrounds',
          features: this.fairgroundsGeoJson,
        },
      });

      map.addLayer({
        id: 'fairgrounds-data',
        type: 'fill',
        source: 'fairgrounds',
        maxzoom: 15,
        paint: {
          'fill-color': this.colorExpression(this.fairgroundsGeoJson),
        },
      });

      map.addSource('offers', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          name: 'offers',
          features: this.offersGeoJson,
        },
      });

      map.addLayer({
        id: 'offers-data',
        type: 'fill',
        source: 'offers',
        minzoom: 15,
        paint: {
          'fill-color': this.colorExpression(this.offersGeoJson),
        },
      });

      map.on('click', (e) => {
        // console.log(e, `[${e.lngLat.lng}, ${e.lngLat.lat}]`);
        const features = map.queryRenderedFeatures(e.point, {
          layers: this.layersList,
        });

        if (features.length === 0) {
          return;
        }

        const feature = features[0];

        if (feature.source === 'fairgrounds') {
          this.$emit('select-fairground', feature.properties.id);
        }

        if (feature.source === 'offers' && this.offerIds.includes(feature.properties.id)) {
          this.$emit('select-offer', feature.properties.id);
        }

        if (feature.properties.fairgroundId && feature.type === 'Feature') {
          this.$emit('select-fairground', feature.properties.fairgroundId);
        }
      });

      this.$emit('map-loaded');
    },
    colorExpression(data) {
      if (data.length === 0) {
        return '#FF0000';
      }
      const expression = ['match', ['get', 'id']];

      data.forEach((item) => {
        expression.push(item.properties.id, item.properties.color || '#da1073');
      });

      expression.push('#FF0000');
      return expression;
    },
    createFillOpacityExpression(id) {
      if (!id) {
        return null;
      }

      const expression = ['match', ['get', 'id'], id, 1, 0.4];
      return expression;
    },
    createFillOpacityOffersExpression(id) {
      if (!this.offerIds.length) {
        return 0.1;
      }

      const expression = ['case'];

      if (id && this.offerIds.includes(id)) {
        expression.push(['==', ['get', 'id'], id], 1);
      }

      if (this.offerIds.length) {
        expression.push(['match', ['get', 'id'], this.offerIds, true, false], 0.5);
      }

      expression.push(0.1);
      return expression;
    },
    getFeaturePosition(geojson, id) {
      const feature = geojson.find((feature) => {
        return feature.properties.id === id;
      });

      if (!feature) {
        return null;
      }

      return feature.properties.center;
    },
    loadImage(imageData) {
      const map = this.map;
      const sourceId = 'point-' + imageData.src;
      this.layersList.push(sourceId);

      map.loadImage(imageData.src, function (error, image) {
        if (error) throw error;

        map.addImage(imageData.src, image);
        map.addSource(sourceId, {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                properties: {
                  fairgroundId: imageData.fairgroundId,
                },
                geometry: {
                  type: 'Point',
                  coordinates: imageData.position,
                },
              },
            ],
          },
        });

        map.addLayer({
          id: sourceId,
          type: 'symbol',
          source: sourceId,
          maxzoom: imageData.maxzoom || 15,
          layout: {
            'icon-image': imageData.src,
            'icon-size': imageData.iconSize || 0.35,
            'icon-anchor': 'bottom',
            'icon-allow-overlap': true,
            // 'icon-rotation-alignment': 'map', // disable rotation on the map
          },
        });
      });
    },
    addEntersToMap() {
      // not used from 8.09.2022  https://redmine.appswithlove.net/issues/65676
      const map = this.map;

      map.loadImage(MAP_ENTER_SOURCE, (error, image) => {
        if (error) throw error;
        map.addImage(MAP_ENTER_SOURCE, image);
      });

      map.addSource('enters', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: MAP_ENTERS.map((enterCoordinates) => ({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: enterCoordinates,
            },
          })),
        },
      });

      map.addLayer({
        id: 'enters',
        type: 'symbol',
        source: 'enters',
        minzoom: 15,
        layout: {
          'icon-image': MAP_ENTER_SOURCE,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 14, 0.08, 15, 0.1, 16, 0.4],
          'icon-anchor': 'center',
          'icon-allow-overlap': true,
        },
      });
    },
  },
};
</script>
